
<template>
<div class="extra">
<template v-if="currentView == 'home'">

  <div class="page-container sub-pages">
    <sticky-navigation></sticky-navigation>
      <div class=" page-content">
        <div class="extra-section">
          <img class="extra-section-title" src="@/assets/tidslinjer.png" aria-label="Overskrift: Tidslinjer" />
          <ul class="extra-section-nav">
            <li class="extra-section-nav-btn two" @click="goTo('te'); ">Etterforskingen</li>
            <li class="extra-section-nav-btn two" @click="goTo('tr')">Reidars liv</li>
          </ul>
          <img class="extra-section-title" src="@/assets/bilderogdokumenter.png" aria-label="Overskrift: Bilder og dokumenter" />
          <ul class="extra-section-nav">
            <li class="extra-section-nav-btn three" @click="goTo('e1')">Ep. 1</li>
            <li class="extra-section-nav-btn three" @click="goTo('e2')">Ep. 2</li>
            <li class="extra-section-nav-btn three" @click="goTo('e3')">Ep. 3</li>
            <li class="extra-section-nav-btn three" @click="goTo('e4')">Ep. 4</li>
            <li class="extra-section-nav-btn three" @click="goTo('e5')">Ep. 5</li>
            <li class="extra-section-nav-btn three" @click="goTo('e6')">Ep. 6</li>
            <li class="extra-section-nav-btn three" @click="goTo('e7')">Ep. 7</li>
            <li class="extra-section-nav-btn three" @click="goTo('e8')">Ep. 8</li>
            
          </ul>
        </div>
      </div>
      </div>
    </template>
    
    <template v-else>
      <div class="subpage-container">
        <div class="extra-header ">
          <svg class="extra-close" @click="goBack()" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
            <path d="M81.819,18.179C64.246,0.606,35.751,0.607,18.179,18.18c-17.573,17.574-17.573,46.066,0,63.638  c17.572,17.574,46.067,17.576,63.64,0.002C99.392,64.247,99.392,35.753,81.819,18.179z M61.983,68.812L49.999,56.827L38.013,68.812  l-6.825-6.828l11.983-11.985L31.188,38.016l6.828-6.828l11.983,11.984l11.983-11.983l6.828,6.825L56.827,49.999l11.984,11.986  L61.983,68.812z"></path>
          </svg>
        </div>
        <!-- VIEWS 👇🏼 -->
        <view-timeline :title="'Etterforskingen'" :timeline="$store.state.timelines.etterforsking" v-if="currentView == 'te'"></view-timeline>
        <view-timeline :title="'Reidars liv'" :timeline="$store.state.timelines.reidar" v-if="currentView == 'tr'"></view-timeline>
        <view-episode-extra :title="'Episode 1'" :content="$store.state.extra.ep1" v-if="currentView == 'e1'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 2'" :content="$store.state.extra.ep2" v-if="currentView == 'e2'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 3'" :content="$store.state.extra.ep3" v-if="currentView == 'e3'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 4'" :content="$store.state.extra.ep4" v-if="currentView == 'e4'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 5'" :content="$store.state.extra.ep5" v-if="currentView == 'e5'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 6'" :content="$store.state.extra.ep6" v-if="currentView == 'e6'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 7'" :content="$store.state.extra.ep7" v-if="currentView == 'e7'"></view-episode-extra> 
        <view-episode-extra :title="'Episode 8'" :content="$store.state.extra.ep8" v-if="currentView == 'e8'"></view-episode-extra> 
        <!-- VIEWS 👆🏽 -->
        <div class="extra-footer">
          <button class="btn-back" @click="goBack()">Tilbake</button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ViewEpisodeExtra from './extra/viewEpisodeExtra.vue';
import ViewTimeline from "./extra/viewTimeline.vue";
// @ is an alias to /src

export default {  
  components: { ViewTimeline, ViewEpisodeExtra },
  name: "Extra",
  data() {
    return {
      currentView: "home",
    };
  },
  methods: {
    goBack() {
        this.currentView = 'home';
        this.$router.push({ path: '' })
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      },
      goTo(to) {
        this.$router.push({ path: '', query: { view: `${to}` } })
        this.currentView = to;
      }
  },
  created() {
    if(!["te", "tr", "e1", "e2", "e3", "e4", "e5"].includes(this.$route.query.view)) {
      this.goBack();
    }
    if(this.$route.query.view != undefined) {
      this.currentView = this.$route.query.view;
    } 

      
    
    
  }
  
};
</script>
<style lang="scss" scoped>
.subpage-container {
  padding-top: 0; 
  background-color: color('black-2');
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.btn-back {
  margin: 7.5px 0 0 0;
  padding: 4px 10px;
  width: 100px;
  border: 3px solid color('gray-white');
  font-weight: 600;
  background-color: transparent;
  color: color("gray-white");
  &:hover {
    cursor: pointer;
    color: color('black-2');
    background-color: color('gray-white');
    border: 3px solid transparent;
  }

}
.extra {
  
  padding-bottom: 4rem;
  &-header {
    padding: 1rem 1rem 0;
    display: flex;
    justify-content: flex-end;
  }
  &-close {
    height: 30px;
    width: 30px;
    fill: color("white");
    cursor: pointer;
  }

  &-section {
   margin: 0 1rem; 
   display: flex;
   flex-direction: column;
   align-items: center;
   &-title {
    max-height: 60px;
    &:not(:first-child) {
      margin-top: .8rem;
    }
   }
   &-nav {
    padding: 0;
    margin: 0;    
    width: 300px;
    overflow: hidden;
    list-style: none;
    margin-bottom: 1rem;
    &-btn {
      &.three {
        width: 33%;
      }
      &.two {
        width: 50%;
      }
      padding: .4rem 0;
      line-height: 1.5em;
      float: left;
      text-align: center;
      display: inline;
      color: color('white');
      font-size: 1.2em;

        &:hover, &:active, &:focus {
          text-decoration: underline;
          cursor: pointer;
        }    
      }
  }
  }

  &-footer {
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;
}
  
  
}
</style>

